import { AnchorBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AnchorBlock } from './AnchorBlock';

export const AnchorBlockMapping: BlockMapping<AnchorBlockData> = {
  invariant: [
    {
      prop: 'anchor',
      msg: 'Anchor required for anchor',
    },
  ],
  width: 'GRID',
  Component: AnchorBlock,
  AmpComponent: null,
};
